export function showMessage(type, text, duration) {
  window.dispatchEvent(new CustomEvent('flash-message', { detail: { type, text, duration } }));
}

export function clearMessages() {
  window.dispatchEvent(new CustomEvent('flash-clear'));
}
